const OptionList = (props: { title: string, children: React.ReactNode }): JSX.Element => {
	return (
		<section className="options options__margin">
			<div className="options__container container">
				<h3>{props.title}</h3>
				<ul className="options__list">{props.children}</ul>
			</div>
		</section>
	);
};

export default OptionList;
